import {
	DropdownMenu,
	DropdownMenuTrigger,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { ArrowUp, ArrowDown, EyeOff, ChevronsUpDown } from "lucide-react";
import { Column } from "@tanstack/react-table";
import { ReactNode, useState } from "react";

interface Props {
	column: Column<any, unknown>;
	children: ReactNode;
	className?: string;
	disabled?: boolean;
}

export const SortDropdownWrapper = ({ column, children, className = "", disabled = false }: Props) => {
	const [open, setOpen] = useState(false);
	const isSorted = column.getIsSorted();
	const disableClass = disabled ? " cursor-not-allowed opacity-50" : "";
	return (
		<DropdownMenu open={open} onOpenChange={disabled ? () => {} : setOpen}>
			<DropdownMenuTrigger asChild>
				<div
					onClick={!disabled ? () => setOpen(true) : undefined}
					className={
						"flex cursor-pointer select-none items-center justify-center leading-tight gap-1 hover:bg-gray-50 transition-colors duration-150 ease-in-out rounded-md " +
						className +
						disableClass
					}
				>
					{children}
					{isSorted === "asc" ? (
						<ArrowUp className={`h-3 w-3 text-blue-900 ${disableClass}`} />
					) : isSorted === "desc" ? (
						<ArrowDown className={`h-3 w-3 text-blue-900 ${disableClass}`} />
					) : (
						<ChevronsUpDown className={`h-3 w-3 text-muted-foreground opacity-65 ${disableClass}`} />
					)}
				</div>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="start" className="w-40">
				<DropdownMenuItem
					onClick={() => (isSorted === "asc" ? column.clearSorting() : column.toggleSorting(false))}
					className={isSorted === "asc" ? "bg-blue-50" : ""}
				>
					<ArrowUp className="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
					Asc
				</DropdownMenuItem>

				<DropdownMenuItem
					onClick={() => (isSorted === "desc" ? column.clearSorting() : column.toggleSorting(true))}
					className={isSorted === "desc" ? "bg-blue-50" : ""}
				>
					<ArrowDown className="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
					Desc
				</DropdownMenuItem>
				{column.getCanHide?.() && (
					<>
						<DropdownMenuSeparator />
						<DropdownMenuItem onClick={() => column.toggleVisibility(false)}>
							<EyeOff className="mr-2 h-3.5 w-3.5 text-muted-foreground/70" />
							Hide
						</DropdownMenuItem>
					</>
				)}
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
